import React from 'react';
import { INSTAGRAM_HANDLE, INSTAGRAM_LINK, SUPPORT_EMAIL } from './Shared';
export function Footer() {
  return <footer className="border-t border-amber-500/40 bg-blue-950 py-12 text-stone-50" data-id="element-112" data-mp="3gfiyquovsxjx">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-113" data-mp="32oe1fz8zkhcr">
        <div className="mb-8 rounded-2xl border border-white/10 bg-white/5 p-6 text-sm leading-relaxed" data-id="element-114" data-mp="36pfu1x8edv5r">
          <p data-id="element-115" data-mp="3ufa3s5xf73ls">
            <strong className="text-amber-200" data-id="element-116" data-mp="3ueimm04kl8f1">Questions?</strong> Contact us at{' '}
            <a className="break-all font-semibold text-amber-400 hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-117" data-mp="38h5paxxbklh">
              {SUPPORT_EMAIL}
            </a>{' '}
            or on Instagram{' '}
            <a className="font-semibold text-amber-400 hover:underline" href={INSTAGRAM_LINK} data-id="element-118" data-mp="3qd6sbhar3z0i">
              {INSTAGRAM_HANDLE}
            </a>
            .
          </p>
          <p className="mt-3 italic text-stone-50/75" data-id="element-119" data-mp="2a19uhoqc1syc">
            The launch price ends when the countdown reaches zero. The best time to bring more structure to your
            biodecoding practice is now.
          </p>
        </div>

        <div className="mb-10 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-120" data-mp="3gaz2f4jbankm">
          <a className="transition-colors duration-150 ease-out hover:text-amber-400" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-121" data-mp="3v7zwheoz6um9">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-amber-400" href={INSTAGRAM_LINK} data-id="element-122" data-mp="830jhjn6y710">
            📲 {INSTAGRAM_HANDLE}
          </a>
        </div>

        <div className="mb-8" data-id="element-123" data-mp="33nm44yp1hk6">
          <h3 className="mb-2 text-3xl font-bold text-amber-200" data-id="element-124" data-mp="hstsqdzv2a23">LUMEN AKASHA™</h3>
          <p className="text-stone-50/80" data-id="element-125" data-mp="huo533x2gtuk">
            Educational digital resources for biodecoding practitioners and facilitators.
          </p>
          <p className="mt-2 text-stone-50/70" data-id="element-126" data-mp="qsq9zujx86n4">
            Tools created to bring more organisation, clarity, and structure to your professional practice.
          </p>
        </div>

        <div className="border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-127" data-mp="tvmqpiubmimf">
          <p data-id="element-128" data-mp="yu7ictvibtz9">
            © Lumen Akasha™ 2026 — All rights reserved. Unauthorised copying, redistribution, resale, or
            reproduction is prohibited.
          </p>
        </div>
      </div>
    </footer>;
}